<script lang="ts">
  import { Col, Row, Table } from "sveltestrap";
</script>
<div class="pro-group">
  <Row>
    <Col md="6">
      <Table>
        <tbody>
          <tr>
            <td><b>{'Availability'} </b></td>
            <td class="txt-success">{'In stock'}</td>
          </tr>
          <tr>
            <td> <b>{'Brand :'}</b></td>
            <td>{'Pixelstrap'}</td>
          </tr>
        </tbody>
      </Table>
    </Col>
    <Col md="6">
      <Table>
        <tbody>
          <tr>
            <td> <b>{'Seller :'}</b></td>
            <td>{'ABC'}</td>
          </tr>
          <tr>
            <td> <b>{'Fabric :'} </b></td>
            <td>{'Cotton'}</td>
          </tr>
        </tbody>
      </Table>
    </Col>
  </Row>
</div>